import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { loadEventMetaBackgroundStart } from "services/redux/actions/";
import { changeSingleSitesTimeframe } from "services/redux/actions/singleSites";

import { Card, ButtonToolbar } from "react-bootstrap";

import { SelectTimeframe } from "components/Common/Timeframe/SelectTimeframe";

import DataTable from "./DataTable";

function SingleSites() {
  const dispatch = useDispatch();

  const timeframe = useSelector(state => state.sites.all.singleSites.timeframe || 24);

  useEffect(() => {
    dispatch(
      loadEventMetaBackgroundStart({})
    );
  }, []);

  return (
    <>
      <div className="row mb-2">
        <div className="col-12 d-flex">
          <ButtonToolbar
            style={{
              margin: "auto 0 auto auto"
            }}>
            <SelectTimeframe
              className="mr-2"
              timeframe={timeframe}
              changeTimeframe={timeframe => {
                dispatch(changeSingleSitesTimeframe({ timeframe }));
              }}
            />
          </ButtonToolbar>
        </div>
      </div>
      <Card>
        <div>
          <DataTable/>
        </div>
      </Card>
    </>
  )
}

export default SingleSites;